import styles from './Icons.module.css';

const TuidaIcon = ({ size }) => (
  <svg
    version="1.1"
    id="Layer_1"
    className={styles.logoIcon}
	style={{width: size+'rem', height: size+'rem'}}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 128 128"
    xmlSpace="preserve"
  >
    <g id="_x32_">
      <path
        style={{fill: '#FFB531'}}
        d="M4.039,57.204v58.614h27.504V57.204H4.039z M23.137,90.886H12.828v-6.465
		c0-2.63,2.123-4.763,4.753-4.763h0.794c2.64,0,4.763,2.133,4.763,4.763v6.465H23.137z M94.892,57.204v58.614h27.504V57.204H94.892z
		 M113.99,90.886h-10.31v-6.465c0-2.63,2.123-4.763,4.753-4.763h0.794c2.64,0,4.763,2.133,4.763,4.763V90.886z M80.231,72.047
		V35.524h-34.61v36.523l-14.077,0.019v43.752l17.52-0.019v-15.158c0-7.66,6.207-13.867,13.857-13.867h0.01
		c7.651,0,13.857,6.207,13.857,13.867v15.158h17.73V72.047H80.231z M68.085,71.76H57.776v-6.465c0-2.63,2.123-4.763,4.753-4.763
		h0.794c2.64,0,4.763,2.133,4.763,4.763L68.085,71.76L68.085,71.76z M68.085,51.677H57.776v-6.465c0-2.63,2.123-4.763,4.753-4.763
		h0.794c2.64,0,4.763,2.133,4.763,4.763L68.085,51.677L68.085,51.677z"
      />
      <path
        style={{fill: '#1010eeff'}}
        d="M127,38.357h-8.562v4.623h-1.254v-4.623h-7.752v4.623h-1.253v-4.623h-8.316v4.623H98.61v-4.623
		h-9.126l-0.003,15.086l3.44,4.598l0.015,12.765H81.755V37.404h5.279v-6.655L62.89,10.297L38.964,30.754v6.65h5.059v33.403
		l-10.961,0.017l-0.015-12.782l3.47-4.596V38.357h-8.562v4.623h-1.254v-4.623H18.95v4.623h-1.253v-4.623H9.382v4.623H8.128v-4.623
		h-9.125L-1,53.443l3.44,4.597l0.018,59.662h27.485v0.002l20.646-0.026v-16.716c0-6.786,5.516-12.306,12.306-12.306
		c6.78,0,12.296,5.52,12.296,12.306v16.718h19.292v0.022h29.064l-0.017-59.659l3.47-4.597V38.357z M42.086,34.283v-2.09
		l20.812-17.796l21.013,17.8v2.086h-3.718h-1.561H47.145h-1.561C45.584,34.283,42.086,34.283,42.086,34.283z M2.124,49.752v-8.273
		h2.882v4.623h7.497v-4.623h2.071v4.623h7.497v-4.623h1.508v4.623h7.497v-4.623h2.319v8.273H2.124z M2.474,52.873h30.565
		l-2.33,3.085H4.782L2.474,52.873z M5.578,114.579L5.562,59.081h24.365l0.015,12.856v42.643L5.578,114.579L5.578,114.579z
		 M92.922,114.557h-14.61V100.96c0-8.507-6.917-15.428-15.428-15.428c-8.502,0-15.419,6.921-15.419,15.428v13.599l-14.402,0.018
		V73.946l14.081-0.021v-36.52h31.488v36.523h14.289L92.922,114.557L92.922,114.557z M96.044,114.579V71.932h0.017L96.046,59.08
		h24.362l0.016,55.498L96.044,114.579L96.044,114.579z M121.191,55.959H95.264l-2.308-3.085h30.565L121.191,55.959z M123.878,49.752
		H92.607v-8.273h2.882v4.623h7.497v-4.623h2.072v4.623h7.497v-4.623h1.508v4.623h7.497v-4.623h2.319v8.273H123.878z M69.61,45.532
		c0-3.487-2.837-6.324-6.324-6.324h-0.794c-3.482,0-6.314,2.837-6.314,6.324v8.025H69.61V45.532z M66.488,50.435H59.3v-4.903
		c0-1.765,1.432-3.202,3.192-3.202h0.794c1.765,0,3.202,1.436,3.202,3.202C66.488,45.532,66.488,50.435,66.488,50.435z
		 M69.61,65.614c0-3.487-2.837-6.324-6.324-6.324h-0.794c-3.482,0-6.314,2.837-6.314,6.324v8.026H69.61V65.614z M66.488,70.518H59.3
		v-4.904c0-1.765,1.432-3.202,3.192-3.202h0.794c1.765,0,3.202,1.436,3.202,3.202C66.488,65.614,66.488,70.518,66.488,70.518z
		 M18.338,78.418h-0.794c-3.481,0-6.314,2.837-6.314,6.324v8.025h13.431v-8.025C24.662,81.255,21.825,78.418,18.338,78.418z
		 M21.54,89.645h-7.187v-4.903c0-1.765,1.432-3.202,3.192-3.202h0.794c1.765,0,3.201,1.436,3.201,3.202V89.645z M102.078,85.139
		v7.632h13.441v-7.632c0-3.706-3.015-6.721-6.721-6.721S102.078,81.433,102.078,85.139z M105.2,85.139
		c0-1.984,1.614-3.599,3.599-3.599c1.984,0,3.599,1.614,3.599,3.599v4.51H105.2V85.139z M15.355,65.804H9.617v-3.122h5.738V65.804z
		 M23.723,72.295h-5.738v-3.122h5.738V72.295z M39.024,78.736h5.738v3.122h-5.738V78.736z M66.758,78.736h5.738v3.122h-5.738V78.736
		z M91.622,98.116h-5.738v-3.122h5.738V98.116z M37.111,97.863h5.738v3.122h-5.738V97.863z M87.797,102.898h-5.738v-3.122h5.738
		V102.898z M17.752,106.151h5.354v3.122h-5.354V106.151z M20.236,105.448h-5.354v-3.122h5.354V105.448z M99.034,106.151h4.605v3.122
		h-4.605V106.151z M112.662,100.652h4.782v3.122h-4.782V100.652z M111.706,66.942h5.738v3.122h-5.738V66.942z M104.772,73.644
		h-5.738v-3.122h5.738V73.644z"
      />
    </g>
    <g id="Layer_1_1_"></g>
  </svg>
);
export default TuidaIcon;
